module.exports = __webpack_public_path__ + "static/media/1014556.387b23e9.jpg";